import { Store } from '@ngrx/store';
import { Component } from '@angular/core';

import { Observable } from 'rxjs/Observable';

// Reducers & Actions
import * as Account from '../../../my-account/actions/account.actions';
import * as fromCore from '../../../core/reducers';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss']
})
export class AppFooterComponent {
  // Observables
  public termsModalOpened$: Observable<boolean> = this.store.select(state => state.core.account.termsModalOpened);
  public privacyModalOpened$: Observable<boolean> = this.store.select(state => state.core.account.privacyModalOpened);

  // Constructor
  constructor(
    private store: Store<fromCore.State>
  ) { }

  // Toggle privacy modal
  public togglePrivacyModal(event: Event): void {
    // Prevent default
    event.preventDefault();
    // Get modal information
    /*this.store.select(state => state.core.account.privacy).first().subscribe(value => {
      if (!value) this.store.dispatch(new Account.GetPrivacy('en-US'));
    });*/
    // Toggle Modal
    this.store.dispatch(new Account.TogglePrivacyModal());
  }

  // Toggle terms modal
  public toggleTermsModal(event: Event): void {
    // Prevent default
    event.preventDefault();
    // Get modal information
    /*this.store.select(state => state.core.account.terms).first().subscribe(value => {
      if (!value) this.store.dispatch(new Account.GetTerms('en-US'));
    });*/
    // Toggle Modal
    this.store.dispatch(new Account.ToggleTermsModal());
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/app-footer/app-footer.component.ts